export const COLUMNS = [
	{
		id: 'id',
		header: 'Id',
		accessorKey: 'id'
	},
	{
		id: 'first_name',
		header: 'First Name',
		accessorKey: 'first_name'
	},
	{
		id: 'last_name',
		header: 'Last Name',
		accessorKey: 'last_name'
	},
	{
		id: 'date_of_birth',
		header: 'Date of Birth',
		accessorKey: 'date_of_birth'
	},
	{
		id: 'country',
		header: 'Country',
		accessorKey: 'country',
	},
	{
		id: 'phone',
		header: 'Phone',
		accessorKey: 'phone'
	},
	{
		id: 'age',
		header: 'Age',
		accessorKey: 'age',
	},
]

export const GROUPED_COLUMNS = [
	{
		id: 'id',
		header: 'Id',
		accessorKey: 'id'
	},
	{
		Header : 'Name',
		Footer : 'Name',
		columns: [
			{
				Header : 'First Name',
				Footer : 'First Name',
				accessor: 'first_name'
			},
			{
				Header : 'Last Name',
				Footer : 'Last Name',
				accessor: 'last_name'
			},
		]
	},
	{
		Header: 'Info',
		Footer: 'Info',
		columns: [
			{
				Header : 'Date of  Birth',
				Footer : 'Date of  Birth',
				accessor: 'date_of_birth'
			},
			{
				Header : 'Country',
				Footer : 'Country',
				accessor: 'country',
			},
			{
				Header : 'Phone',
				Footer : 'Phone',
				accessor: 'phone'
			},
		]
	},
]